<template>
  <div class="order">
    <div class="container">
        <div class="order-thanks-top" v-bind:class="{ show: orderMade }">
          Спасибо за заказ!
          <br>
          Cкоро мы Вам позвоним
          <br>
            <img :src=logo2>
        </div>
      <div class="order-form">
        <div class="order-form-title">Заказ</div>
        <form action="">
          <div class="order-form-phone-and-name">
            <div class="order-form-item order-form-phone">
              <label >Телефон </label>
              <input v-model.trim="phone" type="tel" >
              <div class="order-error" v-bind:class="{ 'show-error': phoneError }">Введите телефон</div>
            </div>
            <div class="order-form-item order-form-name">
              <label >Имя </label>
              <input v-model.trim="name">
              <div class="order-error"></div>
            </div>
          </div>
          <div class="order-form-address">
            <div class="order-form-full-address-top" v-if=delivery>
              <div class="order-form-item order-form-street">
                <label >Улица </label>
                <input v-model.trim="street">
                <div class="order-error" v-bind:class="{ 'show-error': streetError }">Введите название улицы</div>              
              </div>
              <div class="order-form-item order-form-building">
                <label >Дом </label>
                <input v-model.trim="building">
                <div class="order-error" v-bind:class="{ 'show-error': buildingError }">Дом</div>              
              </div>
            </div>
            <div class="order-form-full-address-bottom" v-if=delivery>
              <div class="order-form-item order-form-flat">
                <label >Квартира </label>
                <input v-model.trim="flat">
              </div>
              <div class="order-form-item order-form-porch">
                <label >Подъезд </label>
                <input v-model.trim="porch">
              </div>
              <div class="order-form-item order-form-floor">
                <label >Этаж </label>
                <input v-model.trim="floor">
              </div>
            </div>
            <div class="order-form-item" v-if=!delivery>
              <label >Адрес самовывоза </label>
              <div class="pickup"> Ул. Богомягкова, дом 12а, ТЦ Меркурий, Кафе </div>
              <div class="order-error"></div>
            </div>
          </div>
          <div class="order-form-choose-and-info">
            <div class="order-form-delivery-choose">
              <div>
                <input type="radio" id="one" v-bind:value="true" v-model="delivery">
                <label for="one">Доставка</label>
              </div>
              <div>
                <input class="check-custom" type="radio" id="two" v-bind:value="false" v-model="delivery">
                <label for="two">Самовывоз</label>
              </div>
            </div>
            <div class="order-form-address-info">
              <router-link to="/delivery">Стоимость доставки</router-link>
            </div>
          </div>
          <div class="order-form-item order-form-comment">
            <label label>Комментарий </label>
            <textarea v-model="comment" placeholder="Комментарий к заказу"></textarea>
            <div class="order-error"></div>
          </div>
          <div class="order-form-item order-form-persons">
            <label>Количество персон</label>
            <div class="order-form-person">
              <div class="order-form-person-minus noselect" v-on:click=personMinus>-</div>
              <div class="order-form-person-count noselect">{{persons}}</div>
              <div class="order-form-person-plus noselect" v-on:click=personPlus>+</div>
            </div>
          </div>
        </form>
        <div class="order-form-button noselect" v-on:click=sendOrder>Заказать</div>
      </div>
      <div class="order-list">
        <div class="order-list-total-price">
          <div>
            Сумма заказа: 
          </div>
          <div>
            {{cartCountPrice}} ₽
          </div>
        </div>
        <div class="order-list-item" v-for="(good,index) in cartAndGoods" :key="good.id">
          <div class="order-list-item-title">
            <div>
               {{good.title}} x {{good.cart}} шт.
            </div>
            <div>
              {{good.price*good.cart}} ₽
            </div>
          </div>
          <div class="order-list-item-description">
            {{good.description}}
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import logo2 from '@/assets/logo2.svg'

function sleep(ms = 0) {
  return new Promise(r => setTimeout(r, ms));
}

export default {
  data() {
    return {
      logo2: logo2,
      phone: '',
      name: '',
      street: '',
      building: '',
      flat: '',
      porch: '',
      floor: '',
      persons: 2,
      comment: '',
      delivery: true,
      orderMade: false,
      phoneError: false,
      streetError: false,
      buildingError: false,
      requestLock: false,
    }
  },
  created: function () {
    if (this.cartCount == 0){
      this.$router.push({ name: 'home'})
    }
  },
  updated: function () {
    if (this.cartCount == 0){
      this.$router.push({ name: 'home'})
    }
  },
  computed: {
    cartAndGoods () {
      return this.$store.getters.getCartAndGoods
    },
    cartCount (){
      return this.$store.getters.getCartCount
    },
    cartCountPrice (){
      return this.$store.getters.getCartCountPrice
    }
  },
  methods: {
    personMinus (){
      if(this.persons>1){
        this.persons--
      }
    },
    personPlus (){
      this.persons++
    },
    async sendOrder () {
      this.phoneError = false
      this.streetError = false
      this.buildingError = false
      if(!this.phone || (!this.street && this.delivery ) || (!this.building && this.delivery )){
        if(!this.phone){
          this.phoneError = true
        }
        if(!this.street && this.delivery ){
          this.streetError = true
        }
        if(!this.building && this.delivery ){
          this.buildingError = true
        }
      }
      else{
        if(!this.requestLock){
          this.requestLock = true
          var message = ''
          message = message +`\n`
          
          message = message +`ЗАКАЗ \n`
          for(var good of this.cartAndGoods){
            message = message +`　${good.title}　-　${good.price} ₽ x ${good.cart}　=　${good.cart*good.price} ₽\n`
          }
          message = message +`Итого: ${this.cartCountPrice} ₽\n`

          message = message +`\nИнформация \n`
          message = message +`　Имя: ${this.name}\n`
          message = message +`　Телефон: ${this.phone}\n`
          if (this.delivery){
            message = message +`　Адрес: улица ${this.street}, дом ${this.building}`
            if (this.flat){
              message = message +`, квартира ${this.flat}`  
            }
            if (this.porch){
              message = message +`, подъезд ${this.porch}`  
            }
            if (this.floor){
              message = message +`, этаж ${this.floor}`  
            }      
            message = message +`\n`
          }else{
            message = message +`　Адрес: САМОВЫВОЗ !\n`
          }
          message = message +`　Кол-во персон: ${this.persons}\n`
          message = message +`　Комментарий: ${this.comment}\n`
          message = message +`___________________________________`
          try{
            const body = await axios.post('https://api.idako.ru/order', {message})
            this.orderMade = true
            fbq('track', 'Purchase', {value: this.cartCountPrice, currency: 'RUB'});
            await sleep(5000)
            this.$store.dispatch('madeOrder')
          }catch{
            alert('Ошибка заказа')
          }
        }
      }
      
    }
  }
}

</script>

<style lang="scss">

[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label
{
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #777;
}
[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #ccc;
  border-radius: 100%;
  background: #fff;
}
[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
  content: '';
  width: 12px;
  height: 12px;
  background: rgb(255, 101, 101);
  position: absolute;
  top: 3px;
  left: 3px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
[type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}

.order{
  .container{
    padding: 0 10px;
    padding-top: 20px;
    display: flex;
    .order-form{
      flex-basis: 50%;
      padding-right: 10px;
      font-size: 20px;
      .order-form-title{
        font-weight: bold;
        margin-bottom: 15px;
      }
      .order-form-item{
        margin-bottom: 0px;
        label{
          color: #777;
          font-size: 20px;
        }
        input,
        textarea{
          margin-top: 5px;
          font-size: 18px;
          width: 100%;
          padding: 10px;
          border: none;
          border:solid 1px #ccc;
          border-radius: 4px;
        }
        textarea{
          height: 100px;
        }
        .pickup{
          margin-top: 5px;
          border:solid 1px transparent;
          font-size: 18px;
          line-height: 1.4;
          min-height: 58px;
          // padding-left: 10px;
        }
        .order-error{
          padding-top: 3px;
          font-size: 14px;
          color: #D86659;
          visibility: hidden;
          &.show-error{
            visibility: visible;
          }
        }
      }
      .order-form-phone-and-name{
        display: flex;
      }
      .order-form-phone{
        margin-right: 10px;
        flex-basis: 50%;
      }
      .order-form-name{
        flex-basis: 50%;
      }
      .order-form-choose-and-info{
        display: flex;
        margin-bottom: 15px;
        margin-top: 5px;
      }
      .order-form-delivery-choose{
          flex-basis: 50%;
          display: flex;
          // align-items: center;
          margin-right: 5px;
          label{
            margin-right: 10px;
          }
        }
      .order-form-address-info{
        flex-basis: 50%;
        // font-size: 18px;
        // margin-top: 2px;
        a{
          color:blueviolet;
          &:hover{
            text-decoration: underline;
          }
        }
      }
      .order-form-address{
        display: flex;
      }
      .order-form-full-address-top{
        display: flex;
        flex-basis: 50%;
        margin-right: 10px;
        .order-form-street{
          flex-basis: 77%;
          margin-right: 10px;
        }
        .order-form-building{
          flex-basis: 23%;
        }
      }
      .order-form-full-address-bottom{
        display: flex;
        flex-basis: 50%;
        .order-form-flat{
          flex-basis: 34%;
          margin-right: 10px;
        }
        .order-form-porch{
          flex-basis: 33%;
          margin-right: 10px;
        }
        .order-form-floor{
          flex-basis: 33%;
        }
      }
      .order-form-person{
        display: flex;
        margin-top: 5px;
        margin-bottom: 10px;
        label{
          width: 100%;
        }
        .order-form-person-count{
          height: 35px;
          width: 35px;
          line-height: 35px;
          font-size: 20px;
          text-align: center;
        }
        .order-form-person-minus,
        .order-form-person-plus{
          cursor: pointer;
          height: 35px;
          width: 35px;
          line-height: 35px;
          font-size: 26px;
          text-align: center;
          color: #777;
          background-color: white;
          border: 1px solid #ccc;
          border-radius: 10px;
        }

      }
      .order-form-button{
        float: right;
        background-color: #D86659;
        color: white;
        padding: 10px 15px;
        border-radius: 10px;
        cursor: pointer;
        margin-bottom: 20px;
        margin-top: -52px;
      }
    }
    .order-list{
      flex-basis: 50%;
      padding-left: 10px;
      .order-list-total-price{
        font-size: 20px;
        font-style: italic;
        border-bottom: 1px solid #ccc;
        padding-bottom: 10px;
        margin-bottom: 15px;
        display: flex;
        justify-content: space-between;
      }
      .order-list-item{
        font-style: italic;
        margin-bottom: 20px;
      }
      .order-list-item-title{
        font-size: 20px;
        margin-bottom: 5px;
        display: flex;
        justify-content: space-between;
      }
      .order-list-item-description{
        font-size: 14px;
        margin-bottom: 5px;
        padding-right: 10px;
      }
    }
    .order-thanks-top{
      height: 100%;
      width: 100%;
      position: fixed;
      background-color: white;
      z-index: 10;
      top: 0;
      left: 0;
      text-align: center;
      padding-top: 200px;
      font-size: 40px;
      visibility: hidden;
      opacity: 0;
      transition: visibility 0s, opacity 0.25s linear;
      &.show{
        visibility: visible;
        opacity: 1;
      }
      img{
        margin-top: 30px;
        height: 200px;
      }
    }
  
  }
}

@media only screen and (max-width: 1300px){
  .order{
    .container{
      .order-form{
        .order-form-delivery-choose{
          justify-content: space-around;
        }
        .order-form-address{
          display: block;
        }
        .order-form-full-address-top{
          margin-right: 0;
        }
        .order-form-delivery-choose{
          margin: 15px 0;
        }
        .order-form-address-info{
          margin-bottom: 15px;
        }
        .order-form-choose-and-info{
          display: block;
        }
      }   
      .order-thanks-top{
        font-size: 30px;
        padding-top: 150px;
      } 
    }
  }
}

@media only screen and (max-width: 959px){
  .order{
    .container{ 
      .order-list{
        .order-list-total-price{
          font-size: 18px;
        }
        .order-list-item-title{
          font-size: 18px;

        }
        .order-list-item-description{
          font-size: 14px;
        }
      }
      .order-thanks-top{
        font-size: 30px;
        padding-top: 50px;
      }
    }
  }
}

@media only screen and (max-width: 600px){
  .order{
    .container{
      .order-form{
        flex-basis: 100%;
        padding-right: 0;
      }
      .order-list{
        display: none;
      }
    
    }
  }

}

@media only screen and (max-width: 500px){
  .order{
    .container{

      display: flex;
      .order-form{
        .order-form-item{
          .label{
            font-size: 18px;
          }
          input,
          textarea{
            font-size: 16px;
          }
        }
      }
      .order-thanks-top{
        font-size: 30px;
        padding-top: 155px;
      }
    
    }
  }

}




</style>